/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Location_FaultyInputs */

const en_reference_location_faulty = /** @type {(inputs: Reference_Location_FaultyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faulty goods`)
};

/**
* | output |
* | --- |
* | "Faulty goods" |
*
* @param {Reference_Location_FaultyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_location_faulty = /** @type {((inputs?: Reference_Location_FaultyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Location_FaultyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_location_faulty(inputs)
});